import { all, fork } from 'redux-saga/effects';
import { sagas } from '@wix/da-shared-react/pkg/redux/shared';
import { sisuFunnelSaga } from '@wix/da-shared-react/pkg/redux/sisuFunnel/saga';

export default function* daDeviationRootSaga() {
  yield all([...sagas.map(fork), fork(sisuFunnelSaga)]);
}
